import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEntity } from '@/hooks/useEntity';
import type { CheckoutQuoteParams } from '@/lib/types/billing';
import { getCheckoutQuote } from '../api/billing.api';
import { billingKeys } from './billing.keys';

/**
 * The backend's price for a purchase (Sprint 7 QA). The review step shows it
 * and never adds anything up itself, so the total on screen and the one
 * Stripe charges come from the same arithmetic.
 *
 * Keeps the previous quote on screen while a new seat count is priced, so the
 * summary does not flash empty on every keystroke.
 *
 * @param params - plan, seats and the APPLIED promo code; null while the
 *   seat count cannot be read, which pauses pricing
 */
export function useCheckoutQuote(params: CheckoutQuoteParams | null) {
  const entityId = useEntity()?.entityId;

  return useQuery({
    queryKey: [...billingKeys.catalogue(entityId ?? 'none'), 'quote', params],
    queryFn: () => getCheckoutQuote(entityId as string, params as CheckoutQuoteParams),
    enabled: Boolean(entityId) && params !== null,
    placeholderData: keepPreviousData,
  });
}
